import { Form, FormInstance, Input, Result } from 'antd'
import { useEffect } from 'react'
import { WarningOutlined } from '@ant-design/icons'
import { useAppSelector } from '../../../store/hooks'
import i18n from '../../../i18n/setupLocalization'
import { requiredRule } from '../../../helpers/rules'
import { selectSelectedUser } from '../../../store/UserReducer'
import { selectSelectedAutomation } from '../../../store/AutomationReducer'

interface Props {
  form: FormInstance
}

const Delete = ({ form }: Props) => {
  const item = useAppSelector(selectSelectedAutomation())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) return <></>

  return <Form form={form} layout="vertical"></Form>
}

export default Delete
